import(/* webpackMode: "eager" */ "/home/node/app/src/app/[locale]/(home-page)/layout.tsx");
